<template>
  <div v-if="showOptInToggler">
    <switch-input
      :show-info-icon="!showSmsDisclaimer"
      :description="smsTermsContent"
      :model-value="session.smsReceiptOptIn"
      label="Text Receipt"
      name="optIn"
      @update:model-value="optInChangeHandler"
    />

    <p
      v-if="showSmsDisclaimer"
      class="content smaller"
      v-html="smsTermsContent"
    />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'SmsReceiptOptIn',

    computed: {
      ...mapGetters('content', ['content']),
      ...mapGetters('merchant', ['merchant']),
      ...mapGetters('session', ['orderDetails', 'session']),

      showOptInToggler() {
        return !['pay', 'table'].includes(this.orderDetails.orderType) && this.merchant.options.showSmsReceiptOption;
      },

      showSmsDisclaimer() {
        return this.merchant.options.showSmsDisclaimer;
      },

      smsTermsContent() {
        return this.content.PaymentScreen.metadata.smsTerms;
      }
    },

    created() {
      this.createdHandler();
    },

    methods: {
      createdHandler() {
        if (this.merchant.options.showSmsReceiptOption) this.optInChangeHandler(this.merchant.options.sendSmsOrderReceiptEnabled);
      },

      optInChangeHandler(optIn) {
        this.$store.dispatch('session/updateSmsReceiptOptIn', optIn);
      }
    }
  };
</script>
